import {
	CORE_PROJECT,
	SOFTWARE_PROJECT,
	type ProjectType,
} from '@jira/platform__project-types/src/project-types.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import { isWorkItemModernizationAllowedForProject } from './isWorkItemModernizationAllowedForProject.tsx';

type ShouldShowWorkItemViewOptions = {
	cloudId: string | undefined;
	issueKey: string | undefined;
	isIssueViewWivEnabled: boolean;
	projectType: ProjectType | undefined;
	isCreatedFromAgenticTemplate?: boolean | null;
	isAgenticWorkItemViewEnabled?: boolean | null;
};

export function shouldShowWorkItemView({
	cloudId,
	issueKey,
	isIssueViewWivEnabled,
	projectType,
	isCreatedFromAgenticTemplate,
	isAgenticWorkItemViewEnabled,
}: ShouldShowWorkItemViewOptions): boolean {
	const isModernizationSupportedProject =
		projectType === SOFTWARE_PROJECT || projectType === CORE_PROJECT;

	// Allow WIV only if allowed projectType AND userPreference.isIssueViewWivEnabled is true
	if (!isIssueViewWivEnabled || !isModernizationSupportedProject) {
		return false;
	}

	if (
		isWorkItemModernizationAllowedForProject(cloudId, issueKey) &&
		// eslint-disable-next-line jira/ff/no-work-item-modernization-exp-val
		expVal('work_item_modernization', 'isEnabled', false)
	) {
		return true;
	}

	return (
		isCreatedFromAgenticTemplate === true &&
		isAgenticWorkItemViewEnabled === true &&
		expVal('work_item_for_quadratic', 'isEnabled', false)
	);
}
